import { useEffect } from 'react';

/* eslint-disable react-hooks/exhaustive-deps */
const useOnMount = cb => useEffect(cb, []);

export default useOnMount;
